export default __webpack_public_path__ + "static/quality-df0a781955ba3aceefa7482394899458.png";